import { Box, Card, CardContent, Stack, Typography } from "@mui/material"

export default function HawaiiShippingRatesCard() {
  return (
    <Card>
      <CardContent>
        <Typography variant="body1">
          We use both UPS and USPS for our Shipping.
        </Typography>
        <Typography variant="body1" mt={1}>
          Our shipping rates are as follows:
        </Typography>
        <Typography component="div" variant="body1" p={0} m={0}>
          <Box width={160} marginY="auto" marginX="auto">
            <Stack direction="row" justifyContent="space-between" spacing={2}>
              <Typography variant="body1">1-2 Bottles:</Typography>
              <Typography variant="body1">$12.00</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" spacing={2}>
              <Typography variant="body1">3-6 Bottles:</Typography>
              <Typography variant="body1">$18.00</Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              spacing={2}
              marginBottom={1}
            >
              <Typography variant="body1">7-12 Bottles:</Typography>
              <Typography variant="body1">$25.00</Typography>
            </Stack>
          </Box>
          <Typography variant="body1" mt={1}>
            These shipping rates do not apply to cases of beers and seltzers.
            Please contact us for shipping quotes on those items.
          </Typography>
        </Typography>
      </CardContent>
    </Card>
  )
}
